export default __webpack_public_path__ + "static/media/rocket_anim_57.8a8fd498.png";